(function () {
  const sourceAngles = {
    antiaging: {
      copy: '500 mg of NMN inside a 1,220 mg, 8-in-1 formula designed to support NAD+, cellular energy and repair pathways, helping men over 50 protect their energy, recovery and physique.',
      order: ['500 mg', '8 actives', 'One daily packet']
    },
    energy: {
      copy: '500 mg of NMN plus seven supporting actives for men over 50 who want more dependable cellular energy, better recovery and a serious healthy-aging routine.',
      order: ['500 mg', '8 actives', 'One daily packet']
    },
    body: {
      copy: 'A 1,220 mg NMN formula that supports cellular energy, training consistency and recovery, giving men over 50 a stronger foundation for waist and body-composition goals.',
      order: ['8 actives', '500 mg', 'One daily packet']
    }
  };

  function setupMediaGallery(root) {
    const story = root.querySelector('[data-yn-gallery-stage-wrap]');
    const stage = root.querySelector('[data-yn-gallery-stage]');
    const rail = root.querySelector('[data-yn-gallery-rail]');
    const thumbs = Array.from(root.querySelectorAll('[data-yn-gallery-thumb]'));
    const dialog = root.querySelector('[data-yn-gallery-dialog]');
    const dialogImage = dialog?.querySelector('[data-yn-gallery-dialog-image]');
    const dialogCaption = dialog?.querySelector('[data-yn-gallery-dialog-caption]');
    const dialogClose = dialog?.querySelector('[data-yn-gallery-dialog-close]');
    const dialogPrevious = dialog?.querySelector('[data-yn-gallery-dialog-prev]');
    const dialogNext = dialog?.querySelector('[data-yn-gallery-dialog-next]');
    if (!(story instanceof HTMLElement) || !(stage instanceof HTMLImageElement) || !(rail instanceof HTMLElement) || thumbs.length < 2) return;
    if (rail.dataset.ynGalleryReady === 'true') return;
    rail.dataset.ynGalleryReady = 'true';

    let activeIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.getAttribute('aria-pressed') === 'true'));
    let requestId = 0;
    let touchStartX = null;
    let touchStartY = null;
    let preserveInlineAfterDialog = false;
    const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    const desktopGallery = window.matchMedia?.('(min-width: 841px)');
    const productIndexes = thumbs
      .map((thumb, index) => thumb.dataset.mediaKind === 'product' ? index : -1)
      .filter((index) => index >= 0);

    function updateSelection(nextIndex) {
      activeIndex = (nextIndex + thumbs.length) % thumbs.length;
      thumbs.forEach((thumb, index) => {
        thumb.setAttribute('aria-pressed', index === activeIndex ? 'true' : 'false');
      });
      thumbs[activeIndex].scrollIntoView({
        behavior: reduceMotion ? 'auto' : 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }

    function clearInlineProductImage() {
      const nextRequestId = ++requestId;
      story.classList.remove('is-gallery-image', 'is-media-loading');
      window.setTimeout(() => {
        if (nextRequestId !== requestId || story.classList.contains('is-gallery-image')) return;
        stage.hidden = true;
        stage.removeAttribute('src');
        stage.removeAttribute('srcset');
        stage.removeAttribute('role');
        stage.removeAttribute('tabindex');
        stage.removeAttribute('aria-label');
        stage.alt = '';
      }, reduceMotion ? 0 : 260);
    }

    function closeDialog() {
      if (dialog instanceof HTMLElement && dialog.open && typeof dialog.close === 'function') dialog.close();
    }

    function openDialog(index, options = {}) {
      const thumb = thumbs[index];
      const src = thumb?.dataset.mediaSrc;
      if (!src || !(dialog instanceof HTMLElement) || !(dialogImage instanceof HTMLImageElement)) return;

      preserveInlineAfterDialog = options.preserveInline === true;
      if (!preserveInlineAfterDialog) clearInlineProductImage();
      updateSelection(index);
      dialogImage.alt = thumb.dataset.mediaAlt || 'NMN Daily product image';
      dialogImage.sizes = '(max-width: 1200px) 82vw, 960px';
      if (thumb.dataset.mediaSrcset) dialogImage.srcset = thumb.dataset.mediaSrcset;
      dialogImage.src = src;
      if (dialogCaption instanceof HTMLElement) dialogCaption.textContent = dialogImage.alt;

      if (!dialog.open) {
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else window.open(src, '_blank', 'noopener');
      }
    }

    function moveDialog(direction) {
      const position = productIndexes.indexOf(activeIndex);
      const nextPosition = (Math.max(0, position) + direction + productIndexes.length) % productIndexes.length;
      const nextIndex = productIndexes[nextPosition];
      if (!desktopGallery?.matches) {
        const thumb = thumbs[nextIndex];
        stage.hidden = false;
        stage.alt = thumb.dataset.mediaAlt || 'NMN Daily product image';
        stage.setAttribute('role', 'button');
        stage.tabIndex = 0;
        stage.setAttribute('aria-label', 'Open enlarged product image');
        if (thumb.dataset.mediaSrcset) stage.srcset = thumb.dataset.mediaSrcset;
        stage.src = thumb.dataset.mediaSrc || '';
        story.classList.add('is-gallery-image');
      }
      openDialog(nextIndex, { preserveInline: !desktopGallery?.matches });
    }

    async function selectMedia(nextIndex, options = {}) {
      const index = (nextIndex + thumbs.length) % thumbs.length;
      const thumb = thumbs[index];

      if (desktopGallery?.matches) {
        if (thumb.dataset.mediaKind === 'hero') {
          closeDialog();
          clearInlineProductImage();
          updateSelection(0);
        } else {
          openDialog(index);
        }
        return;
      }

      const nextRequestId = ++requestId;
      updateSelection(index);

      if (thumb.dataset.mediaKind === 'hero') {
        clearInlineProductImage();
        return;
      }

      const src = thumb.dataset.mediaSrc;
      if (!src) return;
      story.classList.add('is-media-loading');
      stage.hidden = false;
      stage.alt = thumb.dataset.mediaAlt || 'NMN Daily product image';
      stage.setAttribute('role', 'button');
      stage.tabIndex = 0;
      stage.setAttribute('aria-label', 'Open enlarged product image');
      stage.sizes = '(max-width: 840px) 100vw, 62vw';
      if (thumb.dataset.mediaSrcset) stage.srcset = thumb.dataset.mediaSrcset;
      stage.src = src;

      try {
        if (stage.decode) await stage.decode();
      } catch (error) {
        if (!stage.complete || !stage.naturalWidth) {
          story.classList.remove('is-media-loading');
          return;
        }
      }
      if (nextRequestId !== requestId) return;
      story.classList.add('is-gallery-image');
      story.classList.remove('is-media-loading');
      if (options.openDialog !== false) openDialog(index, { preserveInline: true });
    }

    dialogClose?.addEventListener('click', closeDialog);
    dialogPrevious?.addEventListener('click', () => moveDialog(-1));
    dialogNext?.addEventListener('click', () => moveDialog(1));
    dialog?.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog();
    });
    dialog?.addEventListener('close', () => {
      if (!preserveInlineAfterDialog) updateSelection(0);
      preserveInlineAfterDialog = false;
    });
    dialog?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        moveDialog(event.key === 'ArrowRight' ? 1 : -1);
      }
    });

    desktopGallery?.addEventListener?.('change', () => {
      closeDialog();
      clearInlineProductImage();
      updateSelection(0);
    });

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => selectMedia(index));
    });

    stage.addEventListener('click', () => {
      if (activeIndex > 0 && story.classList.contains('is-gallery-image')) {
        openDialog(activeIndex, { preserveInline: true });
      }
    });
    stage.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      if (activeIndex > 0 && story.classList.contains('is-gallery-image')) {
        openDialog(activeIndex, { preserveInline: true });
      }
    });

    rail.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      const direction = event.key === 'ArrowRight' ? 1 : -1;
      const nextIndex = (activeIndex + direction + thumbs.length) % thumbs.length;
      selectMedia(nextIndex);
      thumbs[nextIndex].focus();
    });

    story.addEventListener('touchstart', (event) => {
      const touch = event.changedTouches[0];
      touchStartX = touch?.clientX ?? null;
      touchStartY = touch?.clientY ?? null;
    }, { passive: true });

    story.addEventListener('touchend', (event) => {
      if (desktopGallery?.matches) return;
      if (touchStartX === null || touchStartY === null) return;
      const touch = event.changedTouches[0];
      const deltaX = (touch?.clientX ?? touchStartX) - touchStartX;
      const deltaY = (touch?.clientY ?? touchStartY) - touchStartY;
      touchStartX = null;
      touchStartY = null;
      if (Math.abs(deltaX) < 48 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
      selectMedia(activeIndex + (deltaX < 0 ? 1 : -1), { openDialog: false });
    }, { passive: true });
  }

  function cartSectionIds() {
    return Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
      .map((component) => component.dataset.sectionId)
      .filter(Boolean);
  }

  function cartDrawer(root) {
    return root?.querySelector?.('.yn-nmn-men__cart-control cart-drawer-component')
      || document.querySelector('.yn-nmn-men__cart-control cart-drawer-component')
      || document.querySelector('cart-drawer-component');
  }

  function updateCartBadges(count) {
    document.querySelectorAll('[ref="cartBubbleCount"], .cart-bubble__text-count').forEach((badge) => {
      badge.textContent = count ? String(count) : '';
      badge.classList.toggle('hidden', !count);
    });
    document.querySelectorAll('.cart-bubble').forEach((bubble) => {
      bubble.classList.toggle('visually-hidden', !count);
    });
  }

  function renderedCartCount(root) {
    const drawer = cartDrawer(root);
    const headingBadge = drawer?.querySelector('.cart-drawer__heading [ref="cartBubbleCount"]');
    const badgeCount = Number.parseInt(headingBadge?.textContent || '', 10);
    if (Number.isFinite(badgeCount)) return badgeCount;

    const itemCountText = drawer?.querySelector('[ref="cartItemCount"]')?.textContent || '';
    const itemCountMatch = itemCountText.match(/\d+/);
    return itemCountMatch ? Number.parseInt(itemCountMatch[0], 10) : null;
  }

  function hydrateCartDrawer(root, sections) {
    const currentDrawer = cartDrawer(root);
    const sectionId = currentDrawer?.querySelector('cart-items-component[data-section-id]')?.dataset.sectionId;
    const sectionHtml = sectionId ? sections?.[sectionId] : '';
    if (!currentDrawer || !sectionHtml) return currentDrawer;

    const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
    const nextDrawer = parsed.querySelector('.yn-nmn-men__cart-control cart-drawer-component')
      || parsed.querySelector('cart-drawer-component');
    if (!nextDrawer) return currentDrawer;

    const replacement = document.importNode(nextDrawer, true);
    currentDrawer.replaceWith(replacement);
    return replacement;
  }

  async function fetchCartSections() {
    const sectionIds = cartSectionIds();
    if (!sectionIds.length) return {};

    const url = new URL(window.location.href);
    url.searchParams.set('sections', sectionIds.join(','));
    url.searchParams.delete('variant');
    url.searchParams.delete('purchase_mode');
    url.searchParams.delete('source_angle');
    const response = await fetch(url.toString(), {
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('Unable to refresh the cart drawer.');
    return response.json();
  }

  function displayedCartCount(root) {
    const badge = root?.querySelector?.('.yn-nmn-men__cart-control cart-drawer-component > .header-actions__action [ref="cartBubbleCount"]')
      || document.querySelector('.yn-nmn-men__cart-control cart-drawer-component > .header-actions__action [ref="cartBubbleCount"]');
    const count = Number.parseInt(badge?.textContent || '0', 10);
    return Number.isFinite(count) ? count : 0;
  }

  function cartMatchesExpected(cart, expected) {
    if (!expected) return true;
    if (Number(cart?.item_count || 0) < Number(expected.minimumItemCount || 0)) return false;

    const expectedVariantIds = Array.isArray(expected.variantIds)
      ? expected.variantIds.map(String)
      : expected.variantId ? [String(expected.variantId)] : [];
    return expectedVariantIds.every((variantId) => (
      Array.isArray(cart?.items) && cart.items.some((item) => String(item.variant_id) === variantId)
    ));
  }

  async function currentCart(expected) {
    const retryDelays = expected ? [0, 250, 500, 750, 1000, 1500] : [0];
    let lastCart = null;
    let lastError = new Error('Unable to refresh the cart.');

    for (const delay of retryDelays) {
      if (delay) await new Promise((resolve) => window.setTimeout(resolve, delay));
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js?yn_sync=${Date.now()}`, {
          cache: 'no-store',
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) throw new Error('Unable to refresh the cart.');
        const cart = await response.json();
        lastCart = cart;
        if (cartMatchesExpected(cart, expected)) return cart;
      } catch (error) {
        lastError = error;
      }
    }

    if (lastCart) return lastCart;
    throw lastError;
  }

  function dispatchCartUpdate(root, cart, sourceId, sections, itemCount) {
    const eventTarget = cartDrawer(root)?.querySelector('cart-items-component[data-section-id]') || document;
    eventTarget.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart,
        sourceId,
        data: {
          source: 'yn-nmn-men-50plus',
          itemCount,
          sections: sections || {}
        }
      }
    }));
  }

  async function refreshCartUi(root, cart, sections, forceSectionRefresh, expectedCount) {
    let nextSections = sections || {};
    const drawerSectionId = cartDrawer(root)?.querySelector('cart-items-component[data-section-id]')?.dataset.sectionId;
    const hasCurrentDrawerSection = Boolean(drawerSectionId && nextSections[drawerSectionId]);
    if (forceSectionRefresh || !hasCurrentDrawerSection) {
      try {
        nextSections = await fetchCartSections();
      } catch (error) {
        console.warn('Unable to refresh NMN cart drawer sections', error);
      }
    }
    hydrateCartDrawer(root, nextSections);
    dispatchCartUpdate(root, cart, 'yn-nmn-men-product', nextSections, 1);
    await new Promise((resolve) => window.setTimeout(resolve, 50));
    const count = Number.isFinite(Number(expectedCount))
      ? Number(expectedCount)
      : renderedCartCount(root) ?? Number(cart.item_count || 0);
    updateCartBadges(count);
  }

  async function syncAfterNativeCartControl(root, previousCount) {
    const retryDelays = [300, 500, 800, 1200];
    for (const delay of retryDelays) {
      await new Promise((resolve) => window.setTimeout(resolve, delay));
      try {
        const cart = await currentCart();
        if (Number(cart.item_count) === Number(previousCount)) continue;
        await refreshCartUi(root, cart, {}, true);
        return;
      } catch (error) {
        console.warn('Unable to synchronize NMN cart control', error);
      }
    }
  }

  function setupCartControls(root) {
    const stateNode = root instanceof HTMLElement ? root : document.documentElement;
    if (stateNode.dataset.ynCartControlsReady === 'true') return;
    stateNode.dataset.ynCartControlsReady = 'true';
    root.addEventListener('click', (event) => {
      const control = event.target.closest(
        '.yn-nmn-men__cart-control .cart-items__remove, .yn-nmn-men__cart-control .quantity-minus, .yn-nmn-men__cart-control .quantity-plus'
      );
      if (!control) return;
      const previousCount = displayedCartCount(root);
      syncAfterNativeCartControl(root, previousCount);
    }, true);
  }

  function openCartOrFallback(root) {
    const drawer = cartDrawer(root);
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }
    const trigger = root?.querySelector?.('.yn-nmn-men__cart-control [data-testid="cart-drawer-trigger"]')
      || document.querySelector('[data-testid="cart-drawer-trigger"]');
    if (trigger instanceof HTMLElement) {
      trigger.click();
      return;
    }
    window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
  }

  function setupLabelDialog(root) {
    const dialog = root.querySelector('[data-yn-label-dialog]');
    if (!(dialog instanceof HTMLElement) || dialog.dataset.ynReady === 'true') return;
    dialog.dataset.ynReady = 'true';

    root.querySelectorAll('[data-yn-label-open]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        if (typeof dialog.showModal === 'function') {
          if (!dialog.open) dialog.showModal();
          return;
        }
        const labelUrl = dialog.dataset.labelUrl;
        if (labelUrl) window.open(labelUrl, '_blank', 'noopener');
      });
    });

    dialog.querySelector('[data-yn-label-close]')?.addEventListener('click', () => dialog.close?.());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close?.();
    });
  }

  function setupBundle(root) {
    root.querySelectorAll('[data-yn-men-bundle-form]').forEach((form) => {
      if (form.dataset.ynReady === 'true') return;
      form.dataset.ynReady = 'true';

      const button = form.querySelector('button[type="submit"]');
      const status = form.querySelector('[data-yn-bundle-status]');
      if (!(button instanceof HTMLButtonElement)) return;

      let busy = false;

      const addBundle = async (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (busy || button.disabled) return;
        busy = true;

        let items = [];
        try {
          items = JSON.parse(form.dataset.bundleItems || '[]')
            .filter((item) => item && Number(item.id))
            .map((item) => ({ id: Number(item.id), quantity: Number(item.quantity || 1) }));
        } catch (error) {
          items = [];
        }

        if (items.length !== 2) {
          if (status) status.textContent = 'This pairing is temporarily unavailable. Please choose the products separately.';
          busy = false;
          return;
        }

        const originalLabel = button.textContent;
        const previousCount = displayedCartCount(root);
        const body = { items };
        const sections = cartSectionIds();
        if (sections.length) {
          body.sections = sections.join(',');
          body.sections_url = `${window.location.pathname}${window.location.search}`;
        }

        button.disabled = true;
        button.textContent = 'Adding both products…';
        if (status) status.textContent = '';

        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
          });
          const payload = await response.json();
          if (!response.ok || payload.status) {
            throw new Error(payload.description || payload.message || 'The AM + PM system could not be added.');
          }

          const cart = await currentCart({
            minimumItemCount: previousCount + items.reduce((total, item) => total + item.quantity, 0),
            variantIds: items.map((item) => item.id)
          });
          await refreshCartUi(
            root,
            cart,
            payload.sections,
            false,
            previousCount + items.reduce((total, item) => total + item.quantity, 0)
          );
          button.textContent = 'Both products added';
          if (status) status.textContent = 'Your one-time AM + PM system is in the cart.';
          openCartOrFallback(root);
        } catch (error) {
          busy = false;
          button.disabled = false;
          button.textContent = originalLabel;
          if (status) status.textContent = error.message || 'The AM + PM system could not be added. Please try again.';
          return;
        }

        window.setTimeout(() => {
          busy = false;
          button.disabled = false;
          button.textContent = originalLabel;
        }, 1600);
      };

      button.addEventListener('click', addBundle, true);
      form.addEventListener('submit', addBundle, true);
    });
  }

  function setupPurchaseForms(root) {
    root.querySelectorAll('.yn-nmn-men__product-form').forEach((form) => {
      if (form.dataset.ynAjaxReady === 'true') return;
      form.dataset.ynAjaxReady = 'true';

      form.addEventListener('submit', async (event) => {
        const submitter = event.submitter;
        if (!submitter?.matches?.('[ref="addToCartButton"]')) return;
        event.preventDefault();
        event.stopImmediatePropagation();

        const button = form.querySelector('[ref="addToCartButton"]');
        const status = form.closest('.yn-nmn-men__product-form-shell')?.querySelector('[role="status"]');
        if (!(button instanceof HTMLButtonElement) || button.disabled) return;

        const originalLabel = button.textContent;
        const previousCount = displayedCartCount(root);
        const formData = new FormData(form);
        const item = {
          id: Number(formData.get('id')),
          quantity: Number(formData.get('quantity') || 1)
        };
        const sellingPlanId = Number(formData.get('selling_plan') || 0);
        if (sellingPlanId) {
          item.selling_plan = sellingPlanId;
          item.properties = { _yn_nmn_source: 'men-50plus-subscription' };
        }

        const sections = cartSectionIds();
        const body = { items: [item] };
        if (sections.length) {
          body.sections = sections.join(',');
          body.sections_url = `${window.location.pathname}${window.location.search}`;
        }

        button.disabled = true;
        if (status) status.textContent = 'Adding…';

        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(body)
          });
          const payload = await response.json();
          if (!response.ok || payload.status) {
            throw new Error(payload.description || payload.message || 'This NMN option could not be added.');
          }

          let cart = await currentCart({
            minimumItemCount: previousCount + item.quantity,
            variantId: item.id
          });
          let changedSubscriptionPlan = false;
          if (sellingPlanId) {
            const addedKey = payload.items?.[0]?.key || payload.key;
            const sourceProperty = 'men-50plus-subscription';
            let lineIndex = cart.items.findIndex((line) => line.key === addedKey);
            if (lineIndex < 0) {
              lineIndex = cart.items.findIndex((line) => line.properties?._yn_nmn_source === sourceProperty);
            }

            const cartLine = cart.items[lineIndex];
            const appliedPlanId = Number(cartLine?.selling_plan_allocation?.selling_plan?.id || 0);
            if (lineIndex >= 0 && appliedPlanId !== sellingPlanId) {
              const changeResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
                method: 'POST',
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify({
                  line: lineIndex + 1,
                  quantity: cartLine.quantity,
                  selling_plan: sellingPlanId
                })
              });
              cart = await changeResponse.json();
              if (!changeResponse.ok || cart.status) {
                throw new Error(cart.description || cart.message || 'The subscription plan could not be attached.');
              }
              changedSubscriptionPlan = true;
            }

            const verifiedLine = cart.items.find((line) => line.properties?._yn_nmn_source === sourceProperty);
            const verifiedPlanId = Number(verifiedLine?.selling_plan_allocation?.selling_plan?.id || 0);
            if (verifiedPlanId !== sellingPlanId) {
              const rollbackIndex = cart.items.findIndex((line) => line.properties?._yn_nmn_source === sourceProperty);
              if (rollbackIndex >= 0) {
                await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
                  method: 'POST',
                  headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
                  body: JSON.stringify({ line: rollbackIndex + 1, quantity: 0 })
                });
              }
              throw new Error('The subscription plan could not be verified. No subscription was added.');
            }
          }

          await refreshCartUi(
            root,
            cart,
            payload.sections,
            changedSubscriptionPlan,
            previousCount + item.quantity
          );
          if (status) status.textContent = 'Added';
          button.textContent = 'Added to cart';
          openCartOrFallback(root);
        } catch (error) {
          if (status) status.textContent = error.message || 'This NMN option could not be added. Please try again.';
          button.disabled = false;
          button.textContent = originalLabel;
          return;
        }

        window.setTimeout(() => {
          button.disabled = false;
          button.textContent = originalLabel;
        }, 1200);
      }, true);
    });
  }

  function setupStickyPurchase(root) {
    const sticky = root.querySelector('[data-yn-sticky]');
    const heroPurchase = root.querySelector('#yn-nmn-men-buy.js-yn-nmn-purchase');
    if (!(sticky instanceof HTMLElement) || !(heroPurchase instanceof HTMLElement) || sticky.dataset.ynReady === 'true') return;
    sticky.dataset.ynReady = 'true';

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => {
        sticky.classList.toggle('is-visible', !entry.isIntersecting);
      }, { threshold: .05 });
      observer.observe(heroPurchase);
    } else {
      sticky.classList.add('is-visible');
    }

    sticky.querySelector('[data-yn-sticky-submit]')?.addEventListener('click', () => {
      const heroForm = root.querySelector('#yn-nmn-men-buy form');
      const addButton = heroForm?.querySelector('[ref="addToCartButton"]');
      if (heroForm instanceof HTMLFormElement && addButton instanceof HTMLButtonElement) heroForm.requestSubmit(addButton);
    });
  }

  function setupLanding(root) {
    setupMediaGallery(root);
    if (root.dataset.ynReady === 'true') return;
    root.dataset.ynReady = 'true';
    const scope = document;

    const planButtons = () => Array.from(scope.querySelectorAll('[data-yn-plan]'));
    const planMap = new Map();
    planButtons().forEach((button) => {
      if (!planMap.has(button.dataset.variantId)) {
        planMap.set(button.dataset.variantId, {
          id: String(button.dataset.variantId || ''),
          days: String(button.dataset.days || ''),
          price: String(button.dataset.price || ''),
          available: button.dataset.available === 'true'
        });
      }
    });

    const defaultVariantId = String(root.dataset.defaultVariantId || '');
    const subscriptionVariantId = String(root.dataset.subscriptionVariantId || '');
    const subscriptionPlanId = String(root.dataset.subscriptionPlanId || '');
    const subscriptionPrice = String(root.dataset.subscriptionPrice || '');
    const query = new URLSearchParams(window.location.search);
    const queryVariant = String(query.get('variant') || '');
    const queryMode = query.get('purchase_mode');
    const queryAngle = query.get('source_angle');
    const sourceAngle = sourceAngles[queryAngle] ? queryAngle : 'antiaging';

    let selectedVariantId = planMap.has(queryVariant) && planMap.get(queryVariant).available
      ? queryVariant
      : defaultVariantId;
    let lastOneTimeVariantId = selectedVariantId;
    let purchaseMode = queryMode === 'subscription' && subscriptionPlanId ? 'subscription' : 'one-time';
    if (purchaseMode === 'subscription') selectedVariantId = subscriptionVariantId;

    const angleCopy = root.querySelector('[data-yn-angle-copy]');
    if (angleCopy && sourceAngle !== 'antiaging') angleCopy.textContent = sourceAngles[sourceAngle].copy;
    const factContainer = root.querySelector('[data-yn-angle-facts]');
    if (factContainer && sourceAngle !== 'antiaging') {
      const facts = new Map(Array.from(factContainer.children).map((fact) => [fact.dataset.fact, fact]));
      sourceAngles[sourceAngle].order.forEach((label) => {
        const fact = facts.get(label);
        if (fact) factContainer.appendChild(fact);
      });
    }

    function selectedPlan() {
      return planMap.get(selectedVariantId) || planMap.get(defaultVariantId) || Array.from(planMap.values())[0];
    }

    function updateUrl(actualVariantId) {
      if (!window.history?.replaceState || !actualVariantId) return;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', actualVariantId);
      url.searchParams.set('purchase_mode', purchaseMode);
      if (sourceAngle !== 'antiaging' || url.searchParams.has('source_angle')) {
        url.searchParams.set('source_angle', sourceAngle);
      }
      window.history.replaceState({}, '', url);
    }

    function setButtonLabel(form, text, disabled) {
      const button = form.querySelector('[ref="addToCartButton"]');
      if (!(button instanceof HTMLButtonElement)) return;
      button.disabled = disabled;
      const label = button.querySelector('.add-to-cart-text__content > span > span');
      if (label) label.textContent = text;
      else button.textContent = text;
    }

    function syncPurchaseState() {
      const plan = selectedPlan();
      const isSubscription = purchaseMode === 'subscription';
      const actualVariantId = isSubscription ? subscriptionVariantId : plan?.id;
      const actualPrice = isSubscription ? subscriptionPrice : plan?.price;
      const available = Boolean(isSubscription ? subscriptionPlanId && subscriptionVariantId : plan?.available);

      planButtons().forEach((button) => {
        button.setAttribute('aria-pressed', !isSubscription && button.dataset.variantId === actualVariantId ? 'true' : 'false');
      });
      scope.querySelectorAll('[data-yn-mode]').forEach((button) => {
        button.setAttribute('aria-pressed', button.dataset.ynMode === purchaseMode ? 'true' : 'false');
      });

      scope.querySelectorAll('.yn-nmn-men__product-form').forEach((form) => {
        const variantInput = form.querySelector('[data-yn-variant-input]');
        const sellingPlanInput = form.querySelector('[data-yn-selling-plan-input]');
        const paymentButtons = form.querySelector('[data-yn-nmn-men-payment-buttons]');
        if (variantInput) variantInput.value = actualVariantId || '';
        if (sellingPlanInput) {
          sellingPlanInput.value = isSubscription ? subscriptionPlanId : '';
          if (isSubscription) sellingPlanInput.setAttribute('name', 'selling_plan');
          else sellingPlanInput.removeAttribute('name');
        }
        if (paymentButtons) paymentButtons.hidden = !available;

        const label = isSubscription
          ? `Subscribe & Save · ${actualPrice}/month`
          : `Add ${plan?.days}-Day Supply · ${actualPrice}`;
        setButtonLabel(form, available ? label : 'Currently unavailable', !available);
      });

      scope.querySelectorAll('[data-yn-sticky-plan]').forEach((node) => {
        node.textContent = isSubscription ? 'Monthly NMN subscription' : `${plan?.days}-day NMN plan`;
      });
      scope.querySelectorAll('[data-yn-sticky-price]').forEach((node) => { node.textContent = actualPrice || ''; });
      const stickyButton = scope.querySelector('[data-yn-sticky-submit]');
      if (stickyButton instanceof HTMLButtonElement) stickyButton.disabled = !available;
      updateUrl(actualVariantId);
    }

    window.__ynNmnMenPageEvents?.abort?.();
    const pageEvents = new AbortController();
    window.__ynNmnMenPageEvents = pageEvents;
    scope.addEventListener('click', (event) => {
      const planButton = event.target.closest('[data-yn-plan]');
      if (planButton) {
        event.preventDefault();
        const id = String(planButton.dataset.variantId || '');
        if (!planMap.get(id)?.available) return;
        selectedVariantId = id;
        lastOneTimeVariantId = id;
        purchaseMode = 'one-time';
        syncPurchaseState();
        return;
      }

      const modeButton = event.target.closest('[data-yn-mode]');
      if (modeButton) {
        event.preventDefault();
        const nextMode = modeButton.dataset.ynMode;
        if (nextMode === 'subscription' && subscriptionPlanId) {
          purchaseMode = 'subscription';
          selectedVariantId = subscriptionVariantId;
        } else {
          purchaseMode = 'one-time';
          selectedVariantId = planMap.has(lastOneTimeVariantId) ? lastOneTimeVariantId : defaultVariantId;
        }
        syncPurchaseState();
      }
    }, { signal: pageEvents.signal });

    window.__ynNmnMenSyncPurchase = syncPurchaseState;
    syncPurchaseState();
    currentCart().then((cart) => updateCartBadges(cart.item_count)).catch(() => {});
  }

  function initialize() {
    document.querySelectorAll('[data-yn-nmn-men]').forEach(setupLanding);
    setupPurchaseForms(document);
    setupBundle(document);
    setupCartControls(document);
    setupLabelDialog(document);
    setupStickyPurchase(document);
    window.__ynNmnMenSyncPurchase?.();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();

  document.addEventListener('shopify:section:load', initialize);
})();
